import React from "react";
import Styled from "./index.style";

const InputCommon = ({
  children,
  msgError,
  placeholder,
  onChangeValue,
  style,
  disabled,
  value,
  ...restProps
}) => {
  return (
    <Styled style={style} {...restProps}>
      <input
        value={value}
        disabled={disabled}
        autoFocus={true}
        className={`${msgError ? "err" : ""}`}
        placeholder={placeholder}
        onChange={(e) => onChangeValue && onChangeValue(e.target.value)}
        {...restProps}
      />
      {msgError ? <span>{msgError}</span> : null}
    </Styled>
  );
};

export default InputCommon;
